export default class FireLog {
  constructor(obj) {
    this.id = null;
    this.timestamp = null;
    this.tag = null;
    this.subTag = null;
    this.message = null;
    this.severity = null;
    this.group = null;
    this.logger = null;
    this.user = null;

    if (obj.id) {
      this.id = obj.id;
    }
    if (obj.timestamp) {
      this.timestamp = obj.timestamp;
    }
    if (obj.tag) {
      this.tag = obj.tag;
    }
    if (obj.subTag) {
      this.subTag = obj.subTag;
    }
    if (obj.message) {
      this.message = obj.message;
    }
    if (obj.severity) {
      this.severity = obj.severity;
    }
    if (obj.group) {
      this.group = obj.group;
    }
    if (obj.logger) {
      this.logger = obj.logger;
    }
    if (obj.user) {
      this.user = obj.user;
    }
  }
}
